import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class LoaderService {
    // Event emitters for loader to trigger show and hide
    public _requestLoaderShow = new EventEmitter<void>();
    public _requestLoaderHide = new EventEmitter<void>();

    constructor() { }

    public async performAsyncTask<T = void>(task: () => Promise<T>): Promise<T> {
        // Show the loader
        this._requestLoaderShow.emit();

        // Perform the task
        const result = await task();

        // Hide the loader
        this._requestLoaderHide.emit();

        // Return result
        return result;
    }
}
